// Local interface to avoid dependency on caster-specific models
interface Process {
	HeatName?: string;
	AssetName: string;
}

// Pick black or white text for readable contrast against a hex background,
// using the WCAG relative-luminance crossover (~0.179).
export const getContrastTextColor = (hexColor: string): string => {
	const hex = hexColor.replace("#", "");
	if (hex.length !== 6) return "black";

	const toLinear = (channel: number) => {
		const s = channel / 255;
		return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
	};

	const r = toLinear(parseInt(hex.slice(0, 2), 16));
	const g = toLinear(parseInt(hex.slice(2, 4), 16));
	const b = toLinear(parseInt(hex.slice(4, 6), 16));
	const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

	return luminance > 0.179 ? "black" : "white";
};

export const colorHelper = (curr: Process) => {
	let color: string;
	const assetColors = new Map<string, string>();
	const heatNameToColor = new Map<string, string>();
	const colors = [
		"#dae8fc",
		"#d5e8d4",
		"#d17238",
		"#f8cfcc",
		"orange",
		"purple",
		"yellow",
	];
	let colorIndex = 0;
	const getColorForAsset = (assetName: string) => {
		if (!assetColors.has(assetName)) {
			const color = colors[colorIndex % colors.length];
			assetColors.set(assetName, color);
			colorIndex++;
		}
		return assetColors.get(assetName)!;
	};
	if (curr.HeatName) {
		if (heatNameToColor.has(curr.HeatName)) {
			color = heatNameToColor.get(curr.HeatName)!;
		} else {
			color = getColorForAsset(curr.AssetName);
			heatNameToColor.set(curr.HeatName, color);
		}
	} else {
		color = "#e9ecef";
	}

	return color;
};
